export const casualPageConfig = {
  "title": "LTV",
  "titleCN": "LTV",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/monetization/ltv",
  "defaultTab": "ltv",
  "className": "dbd-monetization-ltv-casual",
  "tabList": [
    {
      "id": "ltv",
      "tabName": "LTV",
      "tabNameCN": "LTV",
      "isHaveNotification": true,
      "notificationPath": "/monetization/ltv",
      "path": "/monetization/ltv",
      "logConfig": {
        "pageId": "201502",
        "pageName": "monetizationLtvIaa",
        "extInfo": "monetizationLtvIaa",
        "pagePath": "/monetization/ltv"
      },
      "filters": [
        {
          "name": "CasualLtvFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "monetization/ltv",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "SegmentCo",
                  "className": "segment-light",
                  "style": {
                    "margin-top": "20px"
                  },
                  "props": {
                    "config": {
                      "dataKey": "by_tab",
                      "showOnTimeType": [
                        "week",
                        "month"
                      ],
                      "timeTypeOptionsMap": {
                        "week": [
                          {
                            "name": "Weekly Aggregations",
                            "nameCn": "周聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "User lifetime value calculated from daily data by week. LTV N= Sum Day N revenue for each day in the week / weekly new users",
                              "textCn": "基于自然周每日数据累计计算的用户生命周期价值。 取这周每一日对应的Day N日收入之和 / 周新进 得到对应的LTV N."
                            }
                          }
                        ],
                        "month": [
                          {
                            "name": "Monthly Aggregations",
                            "nameCn": "月聚合",
                            "value": "aggs",
                            "bubble": "",
                            "bubbleCn": "",
                            "info": {
                              "textEn": "User lifetime value calculated from daily data by month. LTV N=Sum Day N revenue for each day in the month / monthly new users",
                              "textCn": "基于自然月每日数据累计计算的用户生命周期价值。 取这月每一日对应的Day N日收入之和 / 月新进 得到对应的LTV N."
                            }
                          }
                        ]
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "RetentionChartContentCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "monetization/ltv",
                          "componentKey": "LtvLineChart",
                          "data": {
                            "timeTypeIsShowCom": [
                              "day",
                              "week",
                              "month"
                            ]
                          },
                          "config": {
                            "props": {
                              "config": {
                                "api": "/api/v1/dashboard/monetization/ltv/linechart",
                                "cycle": false
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "MetricComponent",
                      "path": "monetization/ltv",
                      "componentKey": "LtvTrackingTable",
                      "config": {
                        "props": {
                          "config": {
                            "accumulateSelectMultipleBoxClassName": "dbd-monetization-ltv-casual-tracking-table__accumulate-select-multiple-box",
                            "dateOptionDisabled": false,
                            "api": {
                              "tableApi": "/api/v1/dashboard/monetization/ltv/table",
                              "tableDownloadApi": "/api/v1/dashboard/monetization/ltv/table/download"
                            },
                            "keyDaysConfig": [
                              {
                                "value": 0,
                                "enName": "Key Days",
                                "cnName": "关键日"
                              },
                              {
                                "value": 30,
                                "enName": "1 ~ 30 Days",
                                "cnName": "1 ~ 30 日"
                              },
                              {
                                "value": 60,
                                "enName": "1 ~ 60 Days",
                                "cnName": "1 ~ 60 日"
                              },
                              {
                                "value": 90,
                                "enName": "1 ~ 90 Days",
                                "cnName": "1 ~ 90 日"
                              },
                              {
                                "value": 180,
                                "enName": "1 ~ 180 Days",
                                "cnName": "1 ~ 180 日"
                              },
                              {
                                "value": 270,
                                "enName": "1 ~ 270 Days",
                                "cnName": "1 ~ 270 日"
                              },
                              {
                                "value": 360,
                                "enName": "1 ~ 360 Days",
                                "cnName": "1 ~ 360 日"
                              }
                            ],
                            "formatData": "function(data) {\n                                                    if (!(data === null || data === void 0 ? void 0 : data.average)) return data;\n                                                    var average = JSON.parse(JSON.stringify(data.average));\n                                                    for(var i = 1; i <= 360; i++){\n                                                        var _average_metrics, _key;\n                                                        var key = \"\".concat(i, \"d_ltv\");\n                                                        var _;\n                                                        (_ = (_average_metrics = average.metrics)[_key = key]) !== null && _ !== void 0 ? _ : _average_metrics[_key] = {\n                                                            value: \"\",\n                                                            dod: \"\",\n                                                            sdlw: \"\",\n                                                            change: \"\",\n                                                            share_off_all: \"\"\n                                                        };\n                                                    }\n                                                    return Object.assign(data, {\n                                                        average: average\n                                                    });\n                                                }"
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
